import React from 'react';
import { IconProps } from './types';

const Crehanaicons180: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M7.65 7.8v-4.4c0.050-0.95 0.85-1.7 1.8-1.7 0.9 0.050 1.65 0.75 1.7 1.7v4.4c-0.050 0.95-0.85 1.7-1.8 1.7-0.95-0.050-1.65-0.75-1.7-1.7zM22.6 9.55c0.95 0 1.75-0.75 1.75-1.7 0 0 0 0 0 0v-4.45c-0.050-0.95-0.85-1.7-1.8-1.7-0.9 0.050-1.65 0.75-1.7 1.7v4.4c0 0.95 0.8 1.75 1.75 1.75 0 0 0 0 0 0v0zM32 5.6v23.35c0 0.75-0.65 1.4-1.4 1.4h-29.2c-0.75 0-1.4-0.6-1.4-1.4v-23.35c0-0.8 0.6-1.45 1.4-1.5h3.25c0.75 0 1.4 0.6 1.4 1.4 0 0.75-0.2 1.25-1 1.25h-3.35v6.75h28.65v-6.8h-3.35c-0.75 0-1-0.5-1-1.25s0.65-1.4 1.4-1.4h3.25c0.75 0.1 1.35 0.75 1.35 1.55zM30.3 28.6v-13.45h-28.6v13.45h28.6zM13.45 6.7h5.050c0.55 0.050 1.050-0.4 1.1-1 0-0.1 0-0.2 0-0.25 0-0.75-0.65-1.4-1.4-1.4 0 0 0 0 0 0h-4.4c-0.75 0-1.4 0.6-1.4 1.4-0.1 0.55 0.25 1.1 0.8 1.25 0.1 0 0.2 0 0.25 0z"
    />
  </svg>
);

export default Crehanaicons180;
